export default __webpack_public_path__ + "static/media/8.378094c1.jpg";